// main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import './composables/useTheme';
import './services/axios';
import { msalInstance, initializeMsal } from '@/composables/msalConfig';
import GlobalAlert from './components/GlobalAlert.vue';
import PrimeVue from 'primevue/config';

import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@fortawesome/fontawesome-free/css/regular.min.css';
import '@vuepic/vue-datepicker/dist/main.css';
import 'primevue/resources/themes/aura-light-green/theme.css';
import './assets/custom.css';

import './registerServiceWorker';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

(async () => {
    try {
        // 1) Init MSAL runtime
        await initializeMsal();

        // 2) Handle login redirect ONCE per tab (must be before mount)
        const result = await msalInstance.handleRedirectPromise();
        if (result?.account) {
            msalInstance.setActiveAccount(result.account);
        }

        // 3) If user was already logged in in another tab, pick the existing account
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length && !msalInstance.getActiveAccount()) {
            msalInstance.setActiveAccount(accounts[0]);
        }

        // 4) (Optional) react to login/logout from other tabs
        window.addEventListener('storage', (e) => {
            if (e.key && e.key.startsWith('msal.')) {
                const accs = msalInstance.getAllAccounts();
                msalInstance.setActiveAccount(accs[0] || null);
                // trigger your store/auth refresh here if you keep user state
            }
        });

        // 5) Mount the app only after MSAL state is ready
        createApp(App)
            .use(router)
            .use(i18n)
            .use(PrimeVue, {
                zIndex: { modal: 1100, overlay: 1100, menu: 1100, tooltip: 1100 }
            })
            .component('global-alert', GlobalAlert)
            .mount('#app');

    } catch (err) {
        console.error('Error booting app/MSAL:', err);
    }
})();
